import { ChangeEvent } from 'react'

import Chip from '@mui/material/Chip'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { Button, Col, Grid, Input, Row, Span } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

const prioridades = ['Backlog', 'Bloqueio', 'Subcontratação', 'Data Anexada']

interface IFilterAnalyzePendingCre {
  ordemPrioridades: string[]
  handleChangeOrdemPrioridades: any
  // eslint-disable-next-line no-unused-vars
  pesquisaGeralSearchQuery: string
  setPesquisaGeralSearchQuery: (event: ChangeEvent<HTMLInputElement>) => void
  handlePesquisaGeral: () => void
  handleSearchPendingCre: () => void
  handleClearButton: () => void
}

export const FilterAnalyzePendingCre = ({
  ordemPrioridades,
  handleChangeOrdemPrioridades,
  setPesquisaGeralSearchQuery,
  pesquisaGeralSearchQuery,
  handleSearchPendingCre,
  handlePesquisaGeral,
  handleClearButton
}: IFilterAnalyzePendingCre) => {
  return (
    <>
      <Grid
        gridCols="6fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
      >
        <Col>
          <Span text="Ordem de Prioridade" />
          <Select
            labelId="multiple-chip-label"
            id="multiple-chip"
            multiple
            value={ordemPrioridades}
            onChange={handleChangeOrdemPrioridades}
            variant="standard"
            renderValue={(selected) => (
              <Row gap="5px">
                {selected.map((value) => (
                  <Chip key={value} label={value} />
                ))}
              </Row>
            )}
          >
            {prioridades.map((prioridade) => (
              <MenuItem key={prioridade} value={prioridade}>
                {prioridade}
              </MenuItem>
            ))}
          </Select>
        </Col>
      </Grid>
      <Grid gridCols="6fr 2fr">
        <Col></Col>
        <Col>
          <Input
            label="Pesquisa Geral"
            placeholder="Pesquisar"
            value={pesquisaGeralSearchQuery}
            onChange={setPesquisaGeralSearchQuery}
            onClickIcon={handlePesquisaGeral}
            formValue="pesquisaGeral"
            inputIcon={<MagnifyingGlassIcon />}
          />
        </Col>
      </Grid>
      <Grid
        gridCols="8fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing15} 0 ${SPACING.spacing10} 0`}
      >
        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Limpar"
            variantButton="text"
            onClick={handleClearButton}
          />
          <Button
            text="Ordenar"
            endIcon={<MagnifyingGlassIcon />}
            marginLeft={SPACING.spacing20}
            onClick={handleSearchPendingCre}
          />
        </Row>
      </Grid>
    </>
  )
}
